import API from '../../services/api.svelte.js';





// store Promise to avoid multiple simultaneous API calls
let logsPromise;
let logs = [];
let updated_at = null;

export function search(config = {}) {
    logsPromise = API.search('log/', config)
        .catch(() => {
            return Promise.resolve([]);
        })
        .then(pLogs => {
            logs = pLogs;
            updated_at = new Date();
            return logs;
        })
    ;
    return logsPromise;
}

export function find(id, config = {}) {
    return search().then(logs => logs.find(log => log.id == id));
}



export default {
    search,
    find,
}
